import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import InputFacade from 'vue-input-facade'
Vue.use(InputFacade)
